import type { LandingPageContent } from "../types/content.types";

export const mockContent: LandingPageContent = {
  heroSection: {
    heading: "Transform Any Vehicle Into Your Dream Adventure Home",
    subheading:
      "Professional-grade camping kits built for freedom seekers and modern explorers",
    video: "/videos/hero-video.mp4",
    videoPoster: "/images/hero-poster.jpg",
    ctaText: "Get a Quote Or Inquire",
  },
  manufacturingSection: {
    heading: "In-House Manufacturing",
    summary:
      "Every Bossenberg product starts with precision. Our canopies, racks, sliders, and systems are all manufactured in-house using state-of-the-art technology, ensuring accuracy, consistency, and strength in every piece we create.",
    fullText:
      "Every Bossenberg product starts with precision. Our canopies, racks, sliders, and systems are all manufactured in-house, using state-of-the-art technology. From laser cutting and CNC bending to advanced welding and finishing, every step is handled under one roof to guarantee accuracy, consistency, and strength.\n\nBy keeping manufacturing in-house, we maintain full control over quality and detail, ensuring that every bracket, hinge, and panel meets the same rugged standard our brand is built on. It's not just gear; it's engineering built for the African outdoors.",
    image: "/images/Bossenberg Images/Manufacturing/welding.jpg",
  },
  comboDealsSection: {
    heading: "Our Products",
    combos: [
      {
        title: "Canopy",
        price: "R35,499",
        image:
          "/images/Bossenberg Images/Products/CruiserCanopy.jpg",
      },
      {
        title: "Tray System",
        price: "R100,000 - R330,000",
        image:
          "/images/Bossenberg Images/Products/TraySystemV2.jpg",
      },
      {
        title: "Roof Rack",
        price: "R7,900",
        image:
          "/images/Bossenberg Images/Products/RoofrackTopView2.jpg",
      },
    ],
    ctaText: "Get a Quote Or Inquire",
  },
  hook2Section: {
    heading: "Gallery",
    productImages: [
      "/images/Bossenberg Images/Featured Products/DSC01075.jpg",
      "/images/Bossenberg Images/Featured Products/DSC02726.jpg",
      "/images/Bossenberg Images/Featured Products/DSC04301.jpg",
      "/images/Bossenberg Images/Featured Products/DSC05120.jpg",
      "/images/Bossenberg Images/Featured Products/DSC08755.jpg",
      "/images/Bossenberg Images/Featured Products/DSC08762.jpg",
      "/images/Bossenberg Images/Featured Products/DSC09904.jpg",
      "/images/Bossenberg Images/Featured Products/DSC00044.jpg",
      "/images/Bossenberg Images/Featured Products/DSC00067.jpg",
      "/images/Bossenberg Images/Featured Products/DSC00071.jpg",
      "/images/Bossenberg Images/Featured Products/DSC00086.jpg",
      "/images/Bossenberg Images/Featured Products/DSC09029.jpg",
      "/images/Bossenberg Images/Featured Products/DSC09038.jpg",
      "/images/Bossenberg Images/Featured Products/DSC09061.jpg",
      "/images/Bossenberg Images/Featured Products/DSC09746.jpg",
      "/images/Bossenberg Images/Featured Products/DSC09810.jpg",
      "/images/Bossenberg Images/Featured Products/dji_fly_20251009_082734_0018_1760520574463_photo.jpg",
      "/images/Bossenberg Images/Featured Products/dji_fly_20251009_083022_0020_1760520601246_photo.jpg",
      "/images/Bossenberg Images/Featured Products/dji_fly_20251009_083136_0022_1760520598115_photo.jpg",
      "/images/Bossenberg Images/Featured Products/DSC02831.jpg",
    ],
    ctaText: "Inquire",
  },
  ourTeamSection: {
    heading: "Our Team",
    summary:
      "At Bossenberg, we're more than a company, we're a group of adventurers. We love bakkies, the outdoors, and the kind of lekker times that turn into stories. Our dedicated team works tirelessly on design, sales, assemblies and fitments to make sure every product leaves our floor ready for the wild.",
    fullText:
      "At Bossenberg, we're more than a company, we're a group of adventurers. We love bakkies, the outdoors, and the kind of lekker times that turn into stories. Behind every canopy, rack, and slider are our dedicated team members, working tirelessly on design, sales, assemblies and fitments to make sure every product leaves our floor ready for the wild.\n\nWe're rooted in family values and driven by relationships. To us, it's not just about building gear, it's about building trust, memories, and a community of explorers who share the same passion for adventure.",
    images: [
      "/images/Bossenberg Images/Our Team/team2.jpg",
      "/images/Bossenberg Images/Our Team/team1.jpg",
    ],
  },
  whatsapp: {
    phoneNumber: "27675970358",
    message:
      "Hi, I'm interested in your 4x4 gear and would like to get more information",
  },
};
